













































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapState } from "vuex";

import uniq from "lodash/uniq";

import { STORE_KEY, store } from "./_store";

import ShiftCustomPlanForm from "@/modules/ShiftDetails/ShiftCustomPlan/ShiftCustomPlanForm/ShiftCustomPlanForm.vue";
import ShiftAddWashForm from "@/modules/ShiftDetails/ShiftAddWashForm/ShiftAddWashForm.vue";

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      "loading",
      "loaded",
      "fatalError",

      "relatedPlansList",
      "prevPlansList"
    ])
  }
})
export default class ShiftCustomPlanSemi extends Vue {
  @Prop() documentId!: string;
  @Prop() document!: string;
  @Prop() realBeginTime!: string;
  @Prop() realEndTime!: string;
  @Prop() relTimeOfDay!: string;

  relatedPlansList!: any[];

  opened: any[] = [];

  onDetailToggle(row: any, to: string) {
    if (to == "open") {
      this.opened = uniq([...this.opened, row.id]);
    } else {
      this.opened = uniq(this.opened.filter($row => $row.id != row.id));
    }
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    } else {
      this.$store.dispatch(`${STORE_KEY}/reset`);
    }
  }

  @Watch("realBeginTime")
  onrealBeginTime() {
    console.log("bt => ", this.realBeginTime);
    this.loadData();
  }

  public mounted() {
    this.loadData();
  }

  public loadData() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, {
      documentId: this.documentId,
      realEndTime: this.realEndTime,
      relTimeOfDay: this.relTimeOfDay
    });
  }

  openDocument(row: any) {
    const letter = this.relTimeOfDay ? this.relTimeOfDay[0] : "";
    const semiNumbers = this.relatedPlansList
      .filter((i: any) => i.type !== "wash")
      .map((i: any) => parseInt(i.number))
      .filter((n: number) => !isNaN(n));
    const nextNumber = semiNumbers.length ? Math.max(...semiNumbers) + 1 : 1;
    const initParams = {
      shift_id: this.documentId,
      number: nextNumber + letter,
      kind: "semi",
      ignore_done_delay: false
    };
    console.debug("[ShiftCustomPlanSemi] open plan form", initParams);
    this.$buefy.modal.open({
      component: ShiftCustomPlanForm,
      props: {
        isNew: !row || !row.id,
        documentPreview: row,
        documentId: this.documentId,
        relTimeOfDay: this.relTimeOfDay,
        relatedPlans: this.relatedPlansList,
        initParams: initParams
      },
      events: {
        "form-close": () => {
          this.loadData();
        }
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: "document-form short-form",
      parent: this
    });
  }

  openEquipmentForm(equipments: any[]) {
    const numberStart = this.relatedPlansList.length
      ? Math.max.apply(
          null,
          this.relatedPlansList.map((i: any) => parseInt(i.number))
        ) + 1
      : 1;
    this.$buefy.modal.open({
      component: ShiftAddWashForm,
      props: {
        equipments: equipments,
        typeLine: "custom",
        initParams: {
          shift_id: this.documentId,
          numberStart: numberStart
        }
      },
      events: {
        "form-close": () => {
          this.loadData();
        },
        close: () => {
          this.loadData();
        }
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: "document-form short-form",
      parent: this
    });
  }

  deleteDocument(row: any) {
    this.$buefy.dialog.confirm({
      message: `Удалить партию ${row.number}?`,
      confirmText: "Удалить",
      cancelText: "Отмена",
      trapFocus: true,
      onConfirm: (value: any) => {
        this.$store
          .dispatch(`${STORE_KEY}/deleteDocument`, row)
          .then(result => {
            this.$buefy.snackbar.open(`Запись удалена`);
          })
          .catch(() => {
            this.$buefy.snackbar.open({
              type: "is-warning",
              message: `При сохранении возникли проблемы. Попробуйте позже.`
            });
          });
      }
    });
  }

  restoreDocument(row: any) {
    this.$buefy.dialog.confirm({
      message: `Восстановить партию ${row.number}?`,
      confirmText: "Восстановить",
      cancelText: "Отмена",
      trapFocus: true,
      onConfirm: (value: any) => {
        this.$store
          .dispatch(`${STORE_KEY}/restoreDocument`, row)
          .then(result => {
            this.$buefy.snackbar.open(`Запись удалена`);
          })
          .catch(() => {
            this.$buefy.snackbar.open({
              type: "is-warning",
              message: `При сохранении возникли проблемы. Попробуйте позже.`
            });
          });
      }
    });
  }
}
